import { BaseCountry } from './base-country';

export class CompSearchJurisdiction extends BaseCountry {
  id: number;
  compSearchId: number;
  rangeStatus: string;
  shouldExclude: boolean;
}
